import { useMutation } from '@tanstack/react-query';
import { getAppleToken } from 'shared/services/apple';

export const useLoginUserWithAppleMutation = () =>
  useMutation({
    mutationFn: async () => getAppleToken(),
  });
